import type { MouseEvent } from "react";

export const stopImmediatePropagation = (
  event: MouseEvent
) => {
  event?.nativeEvent?.stopImmediatePropagation?.();
};
